if (!customElements.get('t4-kit-builder')) {
  customElements.define(
    't4-kit-builder',
    class T4KitBuilder extends HTMLElement {
      connectedCallback() {
        this.discount = Number(this.dataset.discount || 0);
        this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
        this.steps = Array.from(this.querySelectorAll('[data-step]'));
        this.list = this.querySelector('[data-summary-list]');
        this.emptyItem = this.list?.querySelector('.build-your-kit__summary-empty');
        this.totalEl = this.querySelector('[data-total]');
        this.savingRow = this.querySelector('[data-saving-row]');
        this.savingEl = this.querySelector('[data-saving]');
        this.button = this.querySelector('[data-add-kit]');
        this.errorEl = this.querySelector('[data-error]');

        this.addEventListener('change', (event) => this.onChange(event));
        this.button?.addEventListener('click', () => this.addToCart());
        this.update();
      }

      onChange(event) {
        const target = event.target;

        if (target.matches('[data-variant-select]')) {
          const option = target.closest('[data-option]');
          const input = option.querySelector('input');
          const selected = target.selectedOptions[0];
          input.value = selected.value;
          input.dataset.price = selected.dataset.price;
          input.dataset.compare = selected.dataset.compare;
          option.querySelector('[data-option-price]').textContent = this.formatMoney(Number(selected.dataset.price));
          if (!input.checked) input.checked = true;
          this.keepSingle(input);
        } else if (target.matches('input[type="checkbox"]')) {
          if (target.checked) this.keepSingle(target);
        }

        this.update();
      }

      // One product per step; picking another swaps the choice.
      keepSingle(input) {
        const step = input.closest('[data-step]');
        step.querySelectorAll('input[type="checkbox"]').forEach((other) => {
          if (other !== input) other.checked = false;
        });
      }

      selectedInputs() {
        return Array.from(this.querySelectorAll('input[type="checkbox"]:checked'));
      }

      update() {
        const inputs = this.selectedInputs();
        let total = 0;
        this.list.querySelectorAll('[data-summary-item]').forEach((item) => item.remove());

        inputs.forEach((input) => {
          const price = Number(input.dataset.price);
          total += price;
          const variantSelect = input.closest('[data-option]').querySelector('[data-variant-select]');
          const variantLabel = variantSelect ? variantSelect.selectedOptions[0].textContent.trim() : '';
          const item = document.createElement('li');
          item.className = 'build-your-kit__summary-item';
          item.dataset.summaryItem = '';
          item.innerHTML = `<span class="build-your-kit__summary-name"></span><span class="build-your-kit__summary-price">${this.formatMoney(price)}</span>`;
          item.querySelector('.build-your-kit__summary-name').textContent = variantLabel
            ? `${input.dataset.title} · ${variantLabel}`
            : input.dataset.title;
          this.list.appendChild(item);
        });

        if (this.emptyItem) this.emptyItem.hidden = inputs.length > 0;
        this.totalEl.textContent = this.formatMoney(total);

        if (this.savingRow) {
          const saving = Math.round((total * this.discount) / 100);
          this.savingRow.hidden = !(inputs.length > 1 && saving > 0);
          this.savingEl.textContent = `-${this.formatMoney(saving)}`;
        }

        const missingRequired = this.steps.some(
          (step) => step.dataset.required === 'true' && !step.querySelector('input:checked')
        );
        this.button.disabled = inputs.length === 0 || missingRequired;
        this.steps.forEach((step) => step.classList.toggle('is-complete', Boolean(step.querySelector('input:checked'))));
      }

      async addToCart() {
        const items = this.selectedInputs().map((input) => ({ id: Number(input.value), quantity: 1 }));
        if (!items.length) return;

        this.button.disabled = true;
        this.button.classList.add('is-loading');
        this.errorEl.hidden = true;

        try {
          const response = await fetch(`${this.dataset.cartAddUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items, sections: 'cart-icon-bubble' }),
          });
          if (!response.ok) throw new Error('add failed');
          const data = await response.json();
          this.refreshCartBubble(data.sections);
          document.dispatchEvent(new CustomEvent('t4:cart-added', { detail: data }));
          await this.openCartDrawer();
          this.reset();
        } catch (error) {
          this.errorEl.hidden = false;
        } finally {
          this.button.classList.remove('is-loading');
          this.update();
        }
      }

      // Same drawer behaviour as quick add: refresh Rebuy's cart and open the Smart Cart drawer.
      async openCartDrawer() {
        const rebuy = window.Rebuy;
        try {
          if (rebuy?.Cart?.fetchCart) await rebuy.Cart.fetchCart();
          if (rebuy?.SmartCart?.show) {
            rebuy.SmartCart.show();
            return;
          }
        } catch (error) {
          // fall through to the theme cart
        }
        const drawer = document.querySelector('cart-drawer');
        if (drawer?.open) {
          drawer.open();
          return;
        }
        window.location.href = this.dataset.cartUrl;
      }

      refreshCartBubble(sections) {
        const html = sections && sections['cart-icon-bubble'];
        const bubble = document.getElementById('cart-icon-bubble');
        if (!html || !bubble) return;
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (fresh) bubble.innerHTML = fresh.innerHTML;
      }

      reset() {
        this.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
          input.checked = false;
        });
      }

      formatMoney(cents) {
        const value = (cents / 100).toFixed(2);
        const [whole, decimals] = value.split('.');
        const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return this.moneyFormat
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${decimals}`)
          .replace(/\{\{\s*amount\s*\}\}/, `${withCommas}.${decimals}`);
      }
    }
  );
}
